<template>
    <div class="" >
        <div class="input-group" style="min-width: 150px">
            <multiselect
                    v-model="filter"
                    track-by="key"
                    label="value"
                    placeholder=""
                    :options="options"
                    :searchable="true"
                    :allow-empty="true"
                    :showLabels="false"
                    :multiple="false"
                    :close-on-select="true"
                    @input="setFilter"
            >
            </multiselect>
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';


    export default {
        name: "SelectFilter",
        components:{ Multiselect },
        props:[
            'data',
            'name',
        ],
        data(){
            return {
                filter: null,
                options: [],
                tmp: []
            }
        },
        methods:{
            init(){
                let vm = this;
                for( let i in vm.tmp ){
                    vm.options.push( {
                        key: vm.tmp[i].key,
                        value: vm.tmp[i].value
                    } );
                }
            },
            setFilter( val ){
                this.$emit( 'set_filter', {
                    key: this.$props.name,
                    value: val ? [val.key] : null
                } );
            }
        },
        beforeMount(){
            this.filter = this.$props.data.value;
        },
        mounted() {
            let vm = this;
            if(typeof vm.$props.data.search === 'function' ){
                vm.$props.data.search.call( vm )
            } else{
                vm.tmp = vm.$props.data.search;
                vm.init()
            }
        },
        watch:{
            tmp:function(){
                if(typeof this.$props.data.search === 'function' )
                    this.init();
            }
        }
    }
</script>
<style src="../../../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

</style>